export const filterEmptyStringFromObject = <T extends {}>(obj: T): Partial<T> => {
  return Object.entries(obj).reduce<Partial<T>>((acc, [key, value]) => {
    if (value !== '') {
      (acc[key as keyof Partial<T>] as unknown) = value;
    }

    return acc;
  }, {});
};
